// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3MVr6","list":"styles_list__16CDr"};